import { useEffect, useRef } from "react";

const CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

function getLoadedMainHash() {
  const scripts = Array.from(document.scripts);
  const main = scripts.find((s) => s.src && /\/static\/js\/main\.[a-f0-9]+\.js/.test(s.src));
  if (!main) return null;
  const match = main.src.match(/main\.([a-f0-9]+)\.js/);
  return match ? match[1] : null;
}

export function useVersionCheck() {
  const loadedHash = useRef(getLoadedMainHash());

  useEffect(() => {
    if (!loadedHash.current) return;

    const check = async () => {
      try {
        const res = await fetch("/asset-manifest.json", { cache: "no-store" });
        if (!res.ok) return;
        const manifest = await res.json();
        const mainJsPath = manifest?.files?.["main.js"];
        if (!mainJsPath) return;
        const match = mainJsPath.match(/main\.([a-f0-9]+)\.js/);
        if (!match) return;
        if (match[1] !== loadedHash.current) {
          window.location.reload();
        }
      } catch {
        // ignore network errors
      }
    };

    const interval = setInterval(check, CHECK_INTERVAL);
    window.addEventListener("focus", check);

    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", check);
    };
  }, []);
}
